export default __webpack_public_path__ + "static/media/large_screen.3174a3c2.jpg";